import React from 'react';
import { Card, CardBody, CardFooter, Row, Col } from 'reactstrap';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import { Form, Field, Button } from '@cordata/buffet';
import { kebabCase } from 'lodash';

import { useExt } from '~/utils';

const initialValues = {};

const validationSchema = Yup.object().shape({
  challenge: Yup.string().required(),
  identifier: Yup.string().required(),
});

const Register = () => {
  const history = useHistory();
  const { externalActionInstance } = useParams();
  const { postIt, eai } = useExt();

  return (
    <Form
      displayName="RegisterConfirm"
      validateOnBlur={false}
      validateOnChange={false}

      initialValues={initialValues}
      validationSchema={validationSchema}

      onSubmit={(values, { setSubmitting, setErrors }) => {
        postIt(values)
          .then(({ data: { message } }) => toast.success(message))
          .then(() =>
            setTimeout(() =>
              history.push(`/ext/${externalActionInstance}/${kebabCase(eai.actionName.name)}`), 1500))
          .catch(({ message }) => {
            setErrors({ server: message });
            toast.error(message);
          })
          .then(() => setSubmitting(false));
      }}
    >
      {({ isSubmitting }) => (
        <Card>
          <CardBody>
            <Row form>
              <Col sm>
                <Field
                  name="challenge"
                  label="Enter the code sent to your mobile phone"
                  placeholder="Enter the code sent to your mobile phone"
                  required
                />
              </Col>

              <Col sm>
                <Field
                  name="identifier"
                  label="Telephone number"
                  type="tel"
                  placeholder="Enter telephone number"
                  required
                />
              </Col>
            </Row>
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button type="submit" disabled={isSubmitting}>
                Sav{isSubmitting ? 'ing' : 'e'}
              </Button>
            </div>
          </CardFooter>
        </Card>
      )}
    </Form>
  );
};

export default Register;
